import script from "./InstagramFlyerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InstagramFlyerCard.vue?vue&type=script&setup=true&lang=js"

import "./InstagramFlyerCard.vue?vue&type=style&index=0&id=1d6ddf48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6ddf48"]])

export default __exports__